import styled from 'styled-components';

export const Container = styled.div`
  margin-left: 15px;
  font-size: 20px;
`;